module.exports = __webpack_public_path__ + "static/media/1_A1_12.437c5657.png";